import ROUTES_ENUM from "../shared/routes-enum";
import { createBrowserRouter } from "react-router-dom";
import { pathJoin } from "../shared/utils/general.utils";
import MainGuard from "./guard/main-guard";
import NotFound from "../ui/not-found/not-found.ui";
import GetStartedUi from "../ui/get-started/get-started.ui";
import TermsAndConditions from "../ui/terms-and-conditions/terms-and-conditions.ui";
import PhoneConfirmation from "../ui/phone-confirmation/phone-confirmation.ui";
import RedirectWithQuery from "./guard/redirect-with-query";
import DownloadAppUi from "../ui/dwonload-app/dwonload-app";
// import path from "path";

const routes = [
    {
        path: ROUTES_ENUM.BASE,
        element: <RedirectWithQuery to={ROUTES_ENUM.TERMS_CONDITIONS} />,
    },
    {
        path: ROUTES_ENUM.TERMS_CONDITIONS,
        element: <TermsAndConditions />
    },
    {
        path: ROUTES_ENUM.BASE_LEAD_REFERENCE,
        element: <TermsAndConditions />
    },
    {
        path: ROUTES_ENUM.BASE_CUSTOMER_REFERENCE,
        element: <TermsAndConditions />
    },
    {
        path: ROUTES_ENUM.LEAD_REGISTER.BASE,
        element: <GetStartedUi />
    },
    {
        path: ROUTES_ENUM.LEAD_REGISTER.LEAD_REFERENCE,
        element: <GetStartedUi />
    },
    {
        path: ROUTES_ENUM.LEAD_REGISTER.CUSTOMER_REFERENCE,
        element: <GetStartedUi />
    },
    {
        path: ROUTES_ENUM.CONFIRM_PHONE,
        element: <PhoneConfirmation />
    },
    {
        path: ROUTES_ENUM.NOT_FOUND,
        element: <NotFound />,
    },
    {
        path: "*",
        element: <NotFound />,
    },
];

// export const getPrerenderRoutes = () => {
//     const prerenderableRoutes = routes.reduce((acc, route) => {
//         if (route && !["*", ":"].includes(route.path)) {
//             acc.push(route.path);
//         }
//         return acc;
//     }, [] as string[]);
//     const customPrerenderRoutes: string[] = [];
//     return [...prerenderableRoutes, ...customPrerenderRoutes];
// };

export const getRouterRoutes = () => {
    // Adds language specific routes
    const formalizedRoutes = routes.reduce((acc, route) => {
        if (route && route.path) {
            acc.push(route);
            acc.push({
                ...route,
                path: pathJoin("/", ":lang", route.path),
            });
        }
        return acc;
    }, [] as any[]);
    // Adds main wrapper
    return [
        {
            path: "/",
            element: <MainGuard />,
            children: formalizedRoutes,
        },
        {
            path: ROUTES_ENUM.DOWNLOAD_APP,
            element: <DownloadAppUi />
        },
    ];
};

const router = createBrowserRouter(getRouterRoutes());
export default router;
